//
// decode-entity.js
//

const decodeEntity = (() => {

    // This prevents any overload from creating multiple objects
    const element = document.createElement('div');

    function decodeHtml(str) {
        if (str && typeof str == 'string') {

            // Eliminate scripts and html tags
            str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
            str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');

            element.innerHTML = str;

            str = element.textContent;
            element.textContent = '';
        }

        return str;
    }

    return decodeHtml;
})();

// Make available globally
window.decodeEntity = decodeEntity;